import { bootstrapSession } from '@jq4race/api-client';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { initAuthClient } from './app/auth-client';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { initSentry } from './app/sentry';
import './index.css';

initAuthClient();
initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('missing #root');

// Hydrate the auth store from the httpOnly refresh cookie before mounting
// the router. The protected-route guard is synchronous (beforeLoad), so it
// would otherwise read session=null and bounce the user to /login on every
// reload. If there's no valid cookie this resolves to null and the guard
// behaves the same as before.
bootstrapSession().finally(() => {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </React.StrictMode>,
  );
});
